import { configureStore } from "@reduxjs/toolkit";
import languageSlice from "./slices/languageSlice";
import tourSlice from "./slices/references/tour";
import authSlice from "./slices/auth";
import pdspSlice from "./slices/references/pdsp";
import countrySlice from "./slices/references/country";
import organizationSettingsSlice from "./slices/references/organizationSettings";
import formOrganizationSettingsSlice from "./slices/form/formOrganizationSettings";
import { navigateTo } from "./navigationService";
import modalUploadLogoSlice from "./slices/modal/modalUploadLogo";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    language: languageSlice.reducer,
    tour: tourSlice.reducer,
    pdsp: pdspSlice.reducer,
    country: countrySlice.reducer,
    organizationSettings: organizationSettingsSlice.reducer,
    formOrganizationSettings: formOrganizationSettingsSlice.reducer,
    modalUploadLogo: modalUploadLogoSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          navigate: navigateTo,
        },
      },
    }),
});
